import React, { Component } from "react";
import * as actions from "../../store/actions/session";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { set,setMulti } from '../../store/actions/pages';
import { setV2 } from "../../store/actions/pagesV2";
import { LayoutSplashScreen } from "../../../_metronic";
import { clearSessionStorage } from "../../common";

class Logout extends Component<any> {
  componentDidMount() {
    //TODO need to pass manual flag here.
    this.props.logout(true);
    localStorage.removeItem("isCriteriaCleared") //Remove both custom maintained states from storage after logout even on same tab
    sessionStorage.removeItem("pages")

    // Clear all session storage items that start with "page-state:"
    clearSessionStorage( 'page-state' );
    
    this.props.setMulti("claimAnalysis-landing", {
        waitForCriteriaFilter: true,
        searchTerm: "",
        selectedFilter: null,
        showIgnoredFilterDialog: false,
        isSearchApiCompleted:false,
        ignoreAcknowledgement: false,
        filter:[],
        customFilter:[]
    });
    this.props.setMulti("triage-landing", {
      waitForCriteriaFilter: true,
      searchTerm: "",
      selectedFilter: null,
      showIgnoredFilterDialog: false,
      isSearchApiCompleted:false,
      ignoreAcknowledgement: false,
      filter:[],
      customFilter:[]
    });
    this.props.setV2('contractsv2-landing', 'contractState', 'finalized')
    sessionStorage.removeItem("duplicated");    
    localStorage.removeItem("rcm-range"); 
    localStorage.removeItem("audit-logs-range");
  }

  render() {
    const { hasAuthToken } = this.props;

    return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth" />;
  }
}

export default connect(
  ({ session } : any ) => ({ hasAuthToken: Boolean(session.authToken) }),
  {...actions,setMulti,setV2}
)(Logout);
